import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { NoticeCommentParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  PostNoticeCommentRepository,
  PostNoticeCommentResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum PostNoticeCommentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: PostNoticeCommentState;
  message: string;
}

const initialState: InitialState = {
  status: PostNoticeCommentState.initial,
  message: "",
};

export const postNoticeComment = createAsyncThunk(
  "postNoticeComment",
  async (param: NoticeCommentParam, { rejectWithValue }) => {
    try {
      const response: PostNoticeCommentResponse =
        await PostNoticeCommentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const postNoticeCommentSlice = createSlice({
  name: "postNoticeComment",
  initialState,
  reducers: {
    resetPostNoticeComment: (state) => {
      state.status = PostNoticeCommentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postNoticeComment.pending, (state) => {
        state.status = PostNoticeCommentState.inProgress;
      })
      .addCase(postNoticeComment.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = PostNoticeCommentState.success;
          state.message = message;
        }
      })
      .addCase(postNoticeComment.rejected, (state, action) => {
        state.status = PostNoticeCommentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectPostNoticeComment = (state: RootState) =>
  state.postNoticeComment;
export const { resetPostNoticeComment } = postNoticeCommentSlice.actions;
export default postNoticeCommentSlice.reducer;
